import{defineMessages}from"react-intl";export var messages=defineMessages({defaultTitle:{id:"jutro-dataview.Editing.defaultTitle",defaultMessage:"Edit item"}});